import { usePermissionsStore } from '@/modules/permissions/stores/permissionsStore'

/* Вкладки и кнопки страницы показываются по тем же правам, что и в PortalSettingsPage */
export const settingsConditions: Record<string, () => boolean> = {
  'settings.canEditOrganization': () => Boolean(usePermissionsStore().modules.hospital?.settings_edit),
  'settings.cannotEditOrganization': () => !usePermissionsStore().modules.hospital?.settings_edit,
  'settings.canEditStructure': () => Boolean(usePermissionsStore().modules.hospital?.structure_edit),
  'settings.canManageIntegrations': () => Boolean(usePermissionsStore().modules.integrations?.manage),
  'settings.canImportNorms': () => Boolean(usePermissionsStore().modules.admin?.admin_panel),
}
